import {connect} from 'react-redux';

import {hideBannerAction} from '../../../../../libs/shared/core/src/store/banners/commonBannerActions';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  AppParametricSelector,
  createShallowEqualSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {makeGetVisibleBannersForPanel} from '../../../../store/panels/app/banners/bannersSelectors';
import {MacrosBannerState} from '../../../../store/panels/app/banners/bannersState';
import {MacrosBanners} from './macrosBanners';
import {isMacrosBanner} from './macrosBannersHelpers';

/*
 * Props.
 */

interface MacrosBannersContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

type MacrosBannersSelector = AppParametricSelector<
  MacrosBannersContainerProps,
  ReadonlyArray<MacrosBannerState>
>;

function makeGetSortedBanners(): MacrosBannersSelector {
  return createShallowEqualSelector([makeGetVisibleBannersForPanel()], (visibleBanners) =>
    visibleBanners.filter(isMacrosBanner),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MacrosBannersContainerProps>()(() => ({
  banners: makeGetSortedBanners(),
}));

const mapDispatchToProps = makeMapDispatchToProps<MacrosBannersContainerProps>()(() => ({
  onClose: hideBannerAction,
}));

export const MacrosBannerContainer = connect(mapStateToProps, mapDispatchToProps)(MacrosBanners);
